/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CarrierToursArrayV3 } from '../models/carrier-tours-array-v-3';
import { ConsigneeToursArrayV3 } from '../models/consignee-tours-array-v-3';
import { getCarrierToursV3 } from '../fn/tours-v-3/get-carrier-tours-v-3';
import { GetCarrierToursV3$Params } from '../fn/tours-v-3/get-carrier-tours-v-3';
import { getConsigneeToursV3 } from '../fn/tours-v-3/get-consignee-tours-v-3';
import { GetConsigneeToursV3$Params } from '../fn/tours-v-3/get-consignee-tours-v-3';


/**
 * Enhanced tour operations with improved pagination, sorting, and filtering capabilities
 */
@Injectable({ providedIn: 'root' })
export class ToursV3Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getCarrierToursV3()` */
  static readonly GetCarrierToursV3Path = '/organization-sites/{organizationSiteKey}/carrier/tours';

  /**
   * Get carrier tours (v3).
   *
   * Get tours for carrier with enhanced pagination and sorting.
   * Supports improved performance with pagination parameters.
   * Can fetch tours from multiple sites using the organizationSiteKeys query parameter.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCarrierToursV3()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCarrierToursV3$Response(params: GetCarrierToursV3$Params, context?: HttpContext): Observable<StrictHttpResponse<CarrierToursArrayV3>> {
    return getCarrierToursV3(this.http, this.rootUrl, params, context);
  }

  /**
   * Get carrier tours (v3).
   *
   * Get tours for carrier with enhanced pagination and sorting.
   * Supports improved performance with pagination parameters.
   * Can fetch tours from multiple sites using the organizationSiteKeys query parameter.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCarrierToursV3$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCarrierToursV3(params: GetCarrierToursV3$Params, context?: HttpContext): Observable<CarrierToursArrayV3> {
    return this.getCarrierToursV3$Response(params, context).pipe(
      map((r: StrictHttpResponse<CarrierToursArrayV3>): CarrierToursArrayV3 => r.body)
    );
  }

  /** Path part for operation `getConsigneeToursV3()` */
  static readonly GetConsigneeToursV3Path = '/organization-sites/{organizationSiteKey}/consignee/tours';

  /**
   * Get consignee tours (v3).
   *
   * Get tours for consignee with enhanced pagination and sorting.
   * Supports improved performance with pagination parameters.
   * Can fetch tours from multiple sites using the organizationSiteKeys query parameter.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConsigneeToursV3()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsigneeToursV3$Response(params: GetConsigneeToursV3$Params, context?: HttpContext): Observable<StrictHttpResponse<ConsigneeToursArrayV3>> {
    return getConsigneeToursV3(this.http, this.rootUrl, params, context);
  }

  /**
   * Get consignee tours (v3).
   *
   * Get tours for consignee with enhanced pagination and sorting.
   * Supports improved performance with pagination parameters.
   * Can fetch tours from multiple sites using the organizationSiteKeys query parameter.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConsigneeToursV3$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsigneeToursV3(params: GetConsigneeToursV3$Params, context?: HttpContext): Observable<ConsigneeToursArrayV3> {
    return this.getConsigneeToursV3$Response(params, context).pipe(
      map((r: StrictHttpResponse<ConsigneeToursArrayV3>): ConsigneeToursArrayV3 => r.body)
    );
  }

}
